import React from 'react';
import PropTypes from 'prop-types';
import deepmerge from 'deepmerge';
import PolarisContext from './PolarisContext';

/**
 * Creates a Context Provider which will pass props to child components.
 * @param {Object} props - Props containing the children and theme keys. Children is internal to React
 * and is used for child components. Theme is an object used for specific theme settings with the following keys:
 * css_prefix: The CSS prefix to be used for all components.
 * Let's keep the theme keys updated.
 */
const PolarisApp = ({ children, config }) => {
  const mergedSettings = deepmerge(PolarisApp.defaultProps.config, config);

  return (
    // @TODO recheck this code
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <PolarisContext.Provider value={{ ...mergedSettings }}>
      {children}
    </PolarisContext.Provider>
  );
};

/**
 * Valid prop types.
 */
PolarisApp.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
  config: PropTypes.shape(),
};

/**
 * Default props.
 */
PolarisApp.defaultProps = {
  children: {},
  config: {
    adConfig: {}, // Default ad config object.
    cssPrefix: 'polaris',
    dateFormat: 'D MMM YYYY',
    dianomi: { // Dianomi configuration id
      contextId: '133',
    },
    disableBrowserRouter: false,
    facebookAppId: null, // used in amp-social-share for the Facebook share
    HelmetComponent: null,
    imageSizesCallback: null,
    LinkComponent: null,
    makeModelData: [], // Used for product selector
    newsletterURL: '', // to be used in the Newsletter component // @TODO this option is soon to be deprecated
    platform: 'canonical', // supported platforms. Values can be canonical or amp
    ratingConfig: { // Used for star rating configuration
      // eslint-disable-next-line
      iconPath: 'M8.902.587l2.162 5.118 5.536.476c.384.033.54.512.249.764l-4.2 3.638 1.259 5.412a.436.436 0 0 1-.65.472L8.5 13.598l-4.757 2.87a.436.436 0 0 1-.65-.473l1.258-5.412-4.2-3.639A.436.436 0 0 1 .4 6.18l5.536-.476L8.098.587a.436.436 0 0 1 .804 0z',
      iconViewBox: '0 0 17 17',
    },
    ratingFillColor: '#4478D2', // for SVG ratings, we need to pass on the color
    ratingFillInactiveColor: '#D5D4D4', // for SVG ratings, we need to pass on the color
    svgSpritePath: '/assets/polaris-sprite.svg', // SVG sprite as defined for SVGSpritemapPlugin in webpack.common.js
  },
};

export default PolarisApp;
